import Api from './Api'

export default {
  getSkyObjects(type) {
    return Api().get(`/sky/${type}`)
  },
  getSkyObject(type, id) {
    return Api().get(`/sky/${type}/${id}`)
  },
  saveSkyObject(type, data) {
    return Api().put(`/sky/${type}`, data)
  }
  // saveUser(data) {
  //   return Api().put('/user', data)
  // }
}